<template>
  <div>
    <LinkWithIcon isDottedUnderline color="gray" @click="isRequestCalendarModalVisible = true">
      <template #icon><IconEmbedded name="plus_2-5" :size="18" /></template>
      <span>Add Calendar</span>
    </LinkWithIcon>

    <SrpModal v-model:isVisible="isRequestCalendarModalVisible" size="medium">
      <template #header>
        <h2 class="global-h2">Add another Calendar</h2>
      </template>
      <template #content>
        <p class="global-p" style="margin-bottom: 16px">
          Multiple calendars let you use different sets of social accounts (e.g., a Local Events Facebook page or a separate Chamber of Commerce account).
        </p>
        <div style="margin-bottom: 16px">
          <label class="global-p" style="display: block; margin-bottom: 8px; font-weight: bold">Calendar name/purpose</label>
          <input v-model="requestCalendarPurpose" class="global-text-input" type="text" placeholder="e.g., Local Events, Chamber of Commerce..." style="width: 450px" />
        </div>
        <p class="global-p">We'll set up the calendar and reach out shortly.</p>
      </template>
      <template #footer>
        <SrpButton color="gray" fill="outlined" style="margin-right: 10px" @click="isRequestCalendarModalVisible = false">Cancel</SrpButton>
        <SrpButton @click="submitCalendarRequest" :isDisabled="isSubmittingCalendarRequest || !requestCalendarPurpose.trim()">
          <template #icon>
            <LoadingIcon v-if="isSubmittingCalendarRequest" :size="20" />
            <IconEmbedded v-else name="send_2" :size="20" />
          </template>
          Request
        </SrpButton>
      </template>
    </SrpModal>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import LinkWithIcon from "@components/LinkWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";
import ContentCalendarRepo from "@repos/ContentCalendarRepo";

const props = defineProps<{
  customerId: string;
}>();

const isRequestCalendarModalVisible = ref(false);
const requestCalendarPurpose = ref("");
const isSubmittingCalendarRequest = ref(false);

async function submitCalendarRequest() {
  if (!requestCalendarPurpose.value.trim()) return;
  isSubmittingCalendarRequest.value = true;
  try {
    await ContentCalendarRepo.requestCalendar(props.customerId, requestCalendarPurpose.value.trim());
    isRequestCalendarModalVisible.value = false;
    requestCalendarPurpose.value = "";
  } finally {
    isSubmittingCalendarRequest.value = false;
  }
}
</script>
